import { post } from 'utils/api';

export const getQrCode = (id) => {
  return post(`/util/getQr/${id}`);
};
export const generateQrCode = {
  getQrCode,
};
